import React from "react";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";
import { FadeUp, MaskLineScroll } from "../components/Reveal";
import { BRAND, IMAGES } from "../lib/brand";

export default function About() {
  return (
    <>
      <SEO
        title="About Cody Lopez — ProForm Paint & Body Denver"
        description="Fifteen-plus years of paint and body work. Formal training across multiple paint applications. Denver's specialty collision, custom paint, and JDM repair specialist."
        canonical={`https://${BRAND.domain}/about`}
      />

      <section className="pt-32 md:pt-40 pb-16 border-b border-ink-700">
        <div className="wrap grid md:grid-cols-12 gap-10">
          <div className="md:col-span-6">
            <div className="label mb-3">— About · 001</div>
            <h1 className="font-display uppercase text-5xl md:text-8xl leading-[0.88] tracking-tight">
              <MaskLineScroll>More than</MaskLineScroll>
              <MaskLineScroll delay={0.08}>a <span className="text-proform-red">body shop</span>.</MaskLineScroll>
            </h1>
            <p className="mt-8 text-chrome-300 text-lg leading-relaxed max-w-lg">
              ProForm was built out of a working obsession with paint, panel, and preparation — and by someone who spends his weekends in the same import and drift community he repairs cars for.
            </p>
          </div>
          <div className="md:col-span-6">
            <FadeUp>
              <div className="clip-frame aspect-[4/5]">
                <img
                  src="https://images.pexels.com/photos/3874337/pexels-photo-3874337.jpeg?auto=compress&cs=tinysrgb&w=1600"
                  alt="JDM performance coupe under focused workshop lighting"
                  loading="lazy"
                />
              </div>
            </FadeUp>
          </div>
        </div>
      </section>

      {[
        {
          h: "Built inside the culture",
          p: "Cody isn't just working on enthusiast cars — he's building them. Drift events, imported chassis, personal projects, and long friendships with importers, tuners, and fabricators shape the way ProForm approaches every unusual car that rolls in.",
        },
        {
          h: "Fifteen years of craft",
          p: "More than fifteen years of hands-on paint and body work. Formal training across multiple paint applications and manufacturer product lines. Deep familiarity with modern refinishing systems, structural repair procedures, and traditional finishing techniques.",
        },
        {
          h: "Trusted with the unusual",
          p: "JDM imports, discontinued models, modified structures, one-off body components, race and drift cars. Vehicles many production shops won't estimate. ProForm assesses them honestly — and only takes them on when the project can be done right.",
        },
        {
          h: "The same standard for every vehicle",
          p: "The daily driver in the parking lot gets the same masking, the same alignment protocol, and the same walk-around as the six-figure build. The Insurance workflow is transparent, respectful of your time, and communicated in plain English.",
        },
      ].map((s, i) => (
        <section key={s.h} className={`py-20 md:py-28 border-b border-ink-700 ${i % 2 ? "bg-ink-900" : ""}`}>
          <div className="wrap grid md:grid-cols-12 gap-10">
            <div className="md:col-span-4">
              <div className="label">— Chapter · 0{i + 2}</div>
              <h2 className="font-display uppercase text-3xl md:text-5xl leading-[0.95] tracking-tight mt-4">
                {s.h}
              </h2>
            </div>
            <div className="md:col-span-8">
              <p className="text-chrome-100 text-lg leading-relaxed max-w-3xl">{s.p}</p>
            </div>
          </div>
        </section>
      ))}

      <section className="py-24 md:py-32">
        <div className="wrap text-center max-w-3xl mx-auto">
          <h3 className="font-display uppercase text-4xl md:text-6xl leading-[0.95] tracking-tight">
            <MaskLineScroll>Tell us about</MaskLineScroll>
            <MaskLineScroll delay={0.08}>the <span className="text-proform-red">car</span>.</MaskLineScroll>
          </h3>
          <div className="mt-10 flex flex-wrap justify-center gap-3">
            <Link to="/estimate" className="btn btn-primary">Request an Estimate →</Link>
            <a href={`tel:${BRAND.phoneRaw}`} className="btn">Call {BRAND.phoneDisplay}</a>
          </div>
        </div>
      </section>
    </>
  );
}
